import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {User} from "../api-users/User";
import {environment} from "../../../environments/environment";


@Injectable({ providedIn: 'root' })
export class EdgeService {
  private baseRef: string = environment.origin;

  constructor(
    private http: HttpClient
  ) { }

  public me(): Observable<User> {
    return this.http.get<User>(`${this.baseRef}/me`);
  }

}
